// extracted by mini-css-extract-plugin
export default {"child":"noresultFound_child__ty0K7","msgEmptychild":"noresultFound_msgEmptychild__6PowM"};